import "./WholeHomeRoomRemodeling.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Remodeling from "./sections/Remodeling";
import Additions from "./sections/Additions";
import Basement from "./sections/Basement";
import InteriorRemodeling from "./sections/InteriorRemodeling";
import RemodelingFaq from "./sections/RemodelingFaq";
import Planner from "./sections/Planner";
import RelatedGuidesAndServices from "./sections/RelatedGuidesAndServices";
import Footer from "@/reusable_sections/Footer";
import RequestEstimate from "./sections/RequestEstimate";
export default function WholeHomeRoomRemodelingPage() {
  return <div>
      <Header />
      <Hero />
      <Remodeling />
      <Additions />
      <Basement />
      <InteriorRemodeling />
      <RequestEstimate />
      <RemodelingFaq />
      <Planner />
      <RelatedGuidesAndServices />
      <Footer />
    </div>;
}